import { render } from "./table-jigsaw.svg?vue&type=template&id=6ccbc2fd?inline"
const script = {}
script.render = render

export default script